import React, { Component, Fragment } from 'react';
import {
    LoadingComponent, PageListComponent, HeaderListComponent,
} from "../../../../common/component/Index";
import DEFINE, { PATHS } from "../../../../../../constants/Define";
import { isEqual, get } from 'lodash';
import * as Func from '../../../../../../helpers/functions';
import SaleReport from '../../../../../../models/SaleReport';

import Wrapper from './../../../../common/component/Wrapper';

import { omit } from 'lodash';
import ReportList from './ReportList';

import './SaleReportsBySKU.less';

let permisionActions = [];
const defaultState = {

};

export default class SaleReportsBySKU extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...defaultState,
            filters: {},
        };
    }

    componentDidMount() {
        this.getSaleReportsBySKU()
    }

    render() {
        const { t, hideHeader, reportState, orderState } = this.props;
        const { isFetching, saleReportBySKU } = reportState;
        return (
            <PageListComponent className="page-sale-report">
                {!hideHeader &&
                    <HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'orders'}
                        titleHeader={t('item.order.saleReportBySKU')}
                    />
                }
                <Wrapper className="">
                    <ReportList report={saleReportBySKU}
                        loading={isFetching}
                        downloading={orderState.isFetchingDownload}
                        onChangeFilters={this.getSaleReportsBySKU}
                        onExportExcel={this.onExportExcel}
                        />
                </Wrapper>
            </PageListComponent>
        );
    }

    getSaleReportsBySKU = (filters) => {
        const { reportState } = this.props;
        if (!filters) filters = omit(reportState.saleReportBySKU, ['items']);
        filters = omit(filters, ['totalCount', 'totalPage'])
        this.setState({ filters });
        this.props.getSaleReportBySKU(filters);
    }

    onExportExcel = (filters) => {
        this.props.exportSkuExcel(filters);
    }

}

SaleReportsBySKU.defaultProps = {
    hideHeader: false,
}
